<script setup>
import { onMounted } from "vue";
import { Chart, registerables } from "chart.js";
import { usePage } from "@inertiajs/vue3";
import { trans } from 'laravel-vue-i18n';

Chart.register(...registerables);

// Registrace pluginu
Chart.register({
    id: "multiply",
    beforeDatasetsDraw(chart) {
        chart.ctx.globalCompositeOperation = "multiply";
    },
    afterDatasetsDraw(chart) {
        chart.ctx.globalCompositeOperation = "source-over";
    },
});

onMounted(() => {
    const canvas = document.getElementById("canvas");

    if (!canvas) {
        console.error("Canvas element not found!");
        return;
    }

    const ctx = canvas.getContext("2d");
    if (!ctx) {
        console.error("Failed to get 2D context!");
        return;
    }

    // Kontrola, jestli je aktivní dark mode
    const isDarkMode = document.documentElement.classList.contains("dark");

    // Gradienty
    const gradientThisWeek = ctx.createLinearGradient(0, 0, 0, 150);
    const gradientPrevWeek = ctx.createLinearGradient(0, 0, 0, 150);

    if (isDarkMode) {
        gradientThisWeek.addColorStop(0, "#1E40AF");
        gradientThisWeek.addColorStop(1, "#3B82F6");

        gradientPrevWeek.addColorStop(0, "#4B5563");
        gradientPrevWeek.addColorStop(1, "#9CA3AF");
    } else {
        gradientThisWeek.addColorStop(0, "#275CE5");
        gradientThisWeek.addColorStop(1, "#6d93f8");

        gradientPrevWeek.addColorStop(0, "#c6d5f4");
        gradientPrevWeek.addColorStop(1, "#e6ecfd");
    }

    // Konfigurace grafu
    const config = {
        type: "line",
        data: {
            labels: [1, 2, 3, 4, 5, 6, 7],
            datasets: [
                {
                    label: "This week",
                    data: Object.values(usePage().props.analytics.daysReservationsThis),
                    backgroundColor: gradientThisWeek,
                    fill: true,
                    borderColor: "transparent",
                    pointBackgroundColor: isDarkMode ? "#F3F4F6" : "#FFFFFF",
                    pointBorderColor: isDarkMode ? "#F3F4F6" : "#FFFFFF",
                    tension: 0.4,
                },
                {
                    label: "Previous week",
                    data: Object.values(usePage().props.analytics.daysReservationsBefore),
                    backgroundColor: gradientPrevWeek,
                    borderColor: "transparent",
                    fill: true,
                    pointBackgroundColor: isDarkMode ? "#F3F4F6" : "#FFFFFF",
                    pointBorderColor: isDarkMode ? "#F3F4F6" : "#FFFFFF",
                    tension: 0.4,
                },
            ],
        },
        options: {
            maintainAspectRatio: true,
            aspectRatio: 2,
            plugins: {
                legend: {
                    display: false,
                },
            },
            elements: {
                point: {
                    radius: 0,
                    hitRadius: 5,
                    hoverRadius: 5,
                },
            },
            scales: {
                x: {
                    display: false,
                },
                y: {
                    display: false,
                    ticks: {
                        beginAtZero: true,
                    },
                },
            },
        },
    };

    new Chart(canvas, config);
});
</script>

<template>
    <div class="relative pt-4">
        <canvas id="canvas" class="p-0 -mr-1" style="max-height: 200px;"></canvas>
        <div class="axis">
            <div class="tick" v-for="(value, index) in Object.values($page.props.analytics.daysReservationsThis)" :key="index">
                <p class="-mb-4 font-black">{{ value === 0 ? '-' : value }}</p>
                <p class="-mb-6">{{ Object.keys($page.props.analytics.daysReservationsThis)[index] }}</p>
                <p>{{ [$t('common.dow_short.mon'), $t('common.dow_short.tue'), $t('common.dow_short.wed'), $t('common.dow_short.thu'), $t('common.dow_short.fri'), $t('common.dow_short.sat'), $t('common.dow_short.sun')][index] }}</p>
                <span class="value value--this">{{ value }}</span>
                <span class="value value--prev">{{ Object.values($page.props.analytics.daysReservationsBefore)[index] }}</span>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.card {
    background-color: #fff;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 300px;
    height: 375px;
    border-radius: 10px;
    overflow: hidden;
}

.axis {
    position: absolute;
    color: #000;
    z-index: 1;
    text-transform: uppercase;
    display: flex;
    width: 100%;
    bottom: 0;
}

.dark .axis {
    color: #d1d5db;
}

.axis .tick {
    flex: 1;
    position: relative;
    overflow: hidden;
    opacity: 0.7;
    font-size: 11px;
    text-align: center;
    line-height: 40px;
    padding-top: 150px;
}

.axis .tick:hover {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.2);
}

.dark .axis .tick:hover {
    background-color: rgba(55, 65, 81, 0.2);
}

.axis .tick .value {
    transform: translateY(-40px);
    transition: 0.3s transform;
    position: absolute;
    top: 20px;
    border-radius: 2px;
    width: 100%;
    line-height: 20px;
    color: #444;
}

.dark .axis .tick .value {
    color: #e5e7eb;
}

.value.value--this {
    color: #5555FF;
    font-weight: bold;
}

.dark .value.value--this {
    color: #3B82F6;
}
</style>
